if (typeof NutritionalInfo !== 'function') {
	class NutritionalInfo extends HTMLElement {
		constructor() {
			super();

			const norm = (s) =>
				(s || '')
					.replace(/&nbsp;/g, ' ')
					.normalize('NFD')
					.replace(/[\u0300-\u036f]/g, '')
					.toLowerCase()
					.trim();

			const META_KEYS = new Set(['cantitate neta', 'servire', 'serviri per pachet']);
			const NUTRITION_KEYS = new Set([
				'informatii nutritionale',
				'informatii per servire',
				'ingredient activ',
				'vitamine si minerale',
			]);

			const isLine = (s) => s && s.length > 0 && s.replace(/\s/g, '').length !== 0;

			const cleanHtmlToLines = (html) =>
				html
					.replace(/<\/p>/gi, '\n')
					.replace(/<br\s*\/?>/gi, '\n')
					.replace(/<\/div>/gi, '\n')
					.replace(/<p[^>]*>/gi, '')
					.split('\n')
					.map((l) => l.replace(/\r/g, '').trim())
					.filter(isLine);

			const leftRight = (rawLine) => {
				const isIndented = /^\s*-/.test(rawLine);
				const line = isIndented ? rawLine.replace(/^\s*-/, '').trim() : rawLine.trim();
				const txt = line.replace(/<[^>]+>/g, '');

				const m = txt
					.split(/,(.+)/)
					.map((s) => s && s.trim())
					.filter(Boolean);
				const parts = m.length >= 2 ? [m[0], m[1]] : [txt];
				return { isIndented, parts };
			};

			const detectSection = (rawLine) => {
				const txt = rawLine.replace(/<[^>]+>/g, '').trim();
				if (!txt.includes(',')) return null;
				const m = txt.split(/,(.+)/);
				if (m.length < 3) return null;
				const left = norm(m[0]);

				if (NUTRITION_KEYS.has(left)) return 'nutrition';
				if (META_KEYS.has(left)) return 'meta';
				return null;
			};

			const rawLines = cleanHtmlToLines(this.innerHTML);

			const tables = [];
			let current = [];
			let currentGroup = null;

			const pushCurrent = () => {
				if (current.length) {
					tables.push(current);
					current = [];
				}
			};

			for (const raw of rawLines) {
				const section = detectSection(raw);

				if (section === 'nutrition') {
					pushCurrent();
					currentGroup = 'nutrition';
					current.push(leftRight(raw));
					continue;
				}

				if (section === 'meta') {
					if (currentGroup !== 'meta') {
						pushCurrent();
						currentGroup = 'meta';
					}
					current.push(leftRight(raw));
					continue;
				}

				if (current.length === 0) currentGroup = null;
				current.push(leftRight(raw));
			}
			pushCurrent();

			let out = '';
			let headerPrinted = false;

			for (const table of tables) {
				out += `<div class="table">`;

				if ((this.dataset.titleLabelLeft || this.dataset.titleLabelRight) && !headerPrinted) {
					headerPrinted = true;
					out += `<span class="table-line table-line--heading">`;
					if (this.dataset.titleLabelLeft) out += `<span>${this.dataset.titleLabelLeft}</span>`;
					if (this.dataset.titleLabelRight) out += `<span>${this.dataset.titleLabelRight}</span>`;
					out += `</span>`;
				}

				for (const row of table) {
					out += `<span class="table-line ${row.isIndented ? 'table-line--indent' : ''}">`;
					for (const cell of row.parts) {
						out += `<span>${cell}</span>`;
					}
					out += `</span>`;
				}

				out += `</div>`;
			}

			this.innerHTML = out;
		}
	}

	if (typeof customElements.get('nutritional-info') === 'undefined') {
		customElements.define('nutritional-info', NutritionalInfo);
	}
}
